<span
  class="ui-spinner"
  [style.width.px]="size()"
  [style.height.px]="size()"
  role="status"
></span>

